module.exports = __webpack_public_path__ + "img/user-picture-1.370c946c.webp";